<template>
	<div class="pay">
		<navtop v-bind:index="''"></navtop>
		<p class="money">￥{{orderRmb}}</p>
		<p class="note">购买内容:{{orderRmb/10}}万齐齐豆</p>
		<div class="selectPaytype">选择支付方式</div>
		<a class="wx" v-on:click="pay(26)" v-if="isWx">
			<i class="iconfont">&#xe620;</i>
			<span>微信支付</span>
		</a>
		<a class="zfb" v-on:click="pay(25)" >
			<i class="iconfont">&#xe65c;</i>
			<span>支付宝支付</span>
		</a>
		<div class="cover" v-if="openBrowser" v-on:click="openBrowser=false">
			<p>充值请点击右上角<br />通过浏览器打开支付</p>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import navtop from '../dating/navTop'
	import navbottom from '../dating/navBottom'
	import cookie from '../../libs/cookie'
	import zfb from '../../libs/ap'

	export default {
		name: 'pay',
		data() {
			return {
				openBrowser: false,
			}
		},
		components: {
			navtop,
			navbottom
		},
		computed:{
			isxiaoxiong(){
				return cookie.get('isxiaoxiong')=='true'
			},
			isWx(){
				return this.isWeixin()
			},
			...mapState(
				['orderRmb']
			)
		},
		methods: {
			pay(paytype) {
				var _this = this
				if(paytype == 25) {
//					_this.openBrowser = true
					_AP.pay("https://order.qxiu.com/v2/unifiedPayController/createOrder?userId=" + cookie.get('uid') + "&payType=" + paytype + "&orderMoney=" + _this.orderRmb + "&openid=" + cookie.get('openid') + "&tradeType=MWEB&oemId="+ (_this.isxiaoxiong?39:201) +"&channelId="+cookie.get('channelid'))
				} else {
					$.ajax({
						type: "get",
						url: "https://order.qxiu.com/v2/unifiedPayController/createOrder?userId=" + cookie.get('uid') + "&payType=" + paytype + "&orderMoney=" + _this.orderRmb + "&openid=" + cookie.get('wxopenid') + "&tradeType=JSAPI&oemId="+ (_this.isxiaoxiong?39:201) +"&channelId="+cookie.get('channelid'),	
						async: true,
						dataType: 'jsonp',
						jsonp: 'callbackname',
						success: function(res) {
							if(res.state !=0){
								alert(res.message);
								return;
							}
							function onBridgeReady() {
								WeixinJSBridge.invoke(
									'getBrandWCPayRequest', {
										"appId": res.content.tokenInfo.appId, //公众号名称，由商户传入     
										"timeStamp": res.content.tokenInfo.timeStamp, //时间戳，自1970年以来的秒数     
										"nonceStr": res.content.tokenInfo.nonceStr, //随机串     
										"package": res.content.tokenInfo.package,
										"signType": "MD5", //微信签名方式：     
										"paySign": res.content.tokenInfo.paySign //微信签名 
									},
									function(res) { 
										if(res.err_msg == "get_brand_wcpay_request:ok") {

										} // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
									}
								);
							}
							if(typeof WeixinJSBridge == "undefined") {
								if(document.addEventListener) {
									document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
								} else if(document.attachEvent) {
									document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
									document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
								}
							} else {
								onBridgeReady();
							}
						},
						error:function(){
							alert('创建订单失败');
						}
					})
				}
			},
			querystr(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if(r != null) return unescape(r[2]);
				return null;
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pay {
		position: absolute;
		top: 0;
		min-width: 15rem;
		bottom: 0;
		background: #fff;
	}
	
	.money {
		font-size: 1.2rem;
		line-height: 3.4rem;
		text-align: center;
		color: #666;
		margin: 0 0.4rem;
		border-bottom: 1px solid #DFDFDF;
	}
	
	.note {
		font-size: 0.64rem;
		padding: 0 0.4rem;
		color: #666;
		line-height: 1.6rem;
	}
	
	.pay .selectPaytype {
		padding: 0 0.4rem;
		line-height: 1.6rem;
		font-size: 0.48rem;
		background: #F5F5F5;
		color: #999;
		margin-bottom: 2.52rem;
	}
	
	.wx,
	.zfb {
		display: block;
		margin: 0 0.4rem;
		line-height: 1.76rem;
		text-align: center;
		color: #fff;
		border-radius: 0.2rem;
		font-size: 0.6rem;
	}
	
	.wx i,
	.zfb i {
		font-size: 1.34rem;
		vertical-align: middle;
		margin-right: 0.25rem;
	}
	
	.wx {
		background: #45C144;
	}
	
	.zfb {
		margin-top: 0.6rem;
		background: #00A1E9;
	}
	
	div.cover {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: 0;
		background: url(../../img/dating/arrow.png) no-repeat 11.16rem 0;
		background-size: 2.88rem;
		background-color: rgba(0, 0, 0, .6)
	}
	
	.cover p {
		margin-top: 2.4rem;
		text-align: center;
		line-height: 1.1rem;
		font-size: 0.84rem;
		color: #EDEDED;
	}
</style>


// WEBPACK FOOTER //
// pay.vue?e5aa7b54